/* eslint-disable no-console */
import React from 'react';
import {
  Avatar,
  Badge,
  Box,
  Heading,
  HStack,
  Image,
  Text,
  Tooltip,
  useColorMode,
} from '@chakra-ui/react';
//@ts-ignore
import Verified from '../../../../assets/icons/verified.svg';
import { useAppDispatch } from '../../../../redux/hooks';
import { HttpsProvider } from '../../../../redux/httpsProviders/types';
import { setManualVerificationSessionProviderName } from '../../../../redux/manualVerification/sessionsDetails';
import {
  setSelectedProviderId,
  updateActiveStep,
} from '../../../../redux/manualVerification/stepperDetails';
import { pxToRem } from '../../../../utils';
import { ProviderCardSkeleton } from '../../../explore/components/provider-skeleton.component';

interface ProviderCardProps {
  providerData?: HttpsProvider | any;
  isLoading?: boolean;
}

export const ProviderCard = ({ providerData, isLoading }: ProviderCardProps) => {
  const { colorMode } = useColorMode();
  const dispatch = useAppDispatch();

  const handleShowAllSessions = () => {
    dispatch(setSelectedProviderId(providerData.httpProviderId));
    dispatch(setManualVerificationSessionProviderName(providerData?.name));
    dispatch(updateActiveStep(2));
  };

  return (
    <>
      {isLoading ? (
        <ProviderCardSkeleton />
      ) : (
        <div onClick={handleShowAllSessions} style={{ cursor: 'pointer' }}>
          <Box
            border={`1px solid ${colorMode === 'dark' ? 'transparent' : '#e5e5ea'}`}
            position="relative"
            borderRadius="lg"
            bg={colorMode === 'dark' ? '#131417' : '#fff'}
            p="16px"
            _hover={{
              borderColor: 'blue.500',
              //backgroundColor: '#feede6',
              //backgroundImage: 'linear-gradient(12deg, #fff 50%, hsla(0, 0%, 100%, 0))',
            }}
            minH={pxToRem(143)}
            transition="background 100ms ease, border-color 100ms ease"
            alignItems="center"
          >
            <HStack justifyContent="space-between">
              <HStack
                position="relative"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <Avatar
                  name={providerData?.name}
                  src={providerData?.logoUrl}
                  width={pxToRem(30)}
                  height={pxToRem(30)}
                  size="sm"
                  textAlign="center"
                  //objectFit='cover'
                />
                {providerData?.isVerified && (
                  <Tooltip
                    label="Verified Official providers maintained by Reclaim Team"
                    placement="top"
                    hasArrow
                  >
                    <Image
                      position="absolute"
                      top={2.5}
                      left={5}
                      src={Verified}
                      alt="verified"
                      width={pxToRem(22)}
                      height={pxToRem(22)}
                    />
                  </Tooltip>
                )}
                <HStack />
              </HStack>
              <HStack>
                {!providerData.isApproved && <Badge colorScheme="red">Inactive</Badge>}
              </HStack>
            </HStack>
            <Box cursor="pointer">
              <Heading as="h2" mt="16px" fontSize={pxToRem(14)}>
                {providerData?.name}
              </Heading>
              <Box>
                <Text mt="6px" fontSize={pxToRem(14)}>
                  {providerData?.description
                    ? providerData?.description
                    : `Proves ${
                        providerData?.name
                          ? providerData.name
                          : providerData?.providerDisplayName
                      } Data`}
                </Text>
              </Box>
            </Box>
            {providerData.providerType === 'PRIVATE' && (
              <Badge
                bottom={0}
                right={0}
                fontSize={pxToRem(12)}
                mb={pxToRem(12)}
                mr={pxToRem(12)}
                colorScheme="green"
                variant="outline"
                position="absolute"
              >
                Private
              </Badge>
            )}
          </Box>
        </div>
      )}
    </>
  );
};
